// test2067
(2067 && 0);
